import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'
import ExtremeVerfiy from 'src/components/ios-extreme/extreme-verfiy2'
import Backup from 'src/components/ios-extreme/backup'
import Congratulations from 'src/components/ios-extreme/congratulations2'
import { getDashboardPathByPlatform } from 'src/utils/appDeviceBridge'
import {
  isResetTimePending,
  resolveExtremeGatePlatform,
  shouldApplyIosExtremeBindGate
} from 'src/utils/iosIcloudBindStatus'
import {
  appendSetupQuery,
  isUnboundPackageSelectionActive,
  readCachedBindOrderId
} from 'src/utils/resolveCurrentOrderId'

const IosExtreme = () => {
  const router = useRouter()
  const store = useSelector(state => state.Common)
  const deviceSwitchRevision = store.deviceSwitchRevision
  const platformType = resolveExtremeGatePlatform(store.currentMode)
  const isIos = shouldApplyIosExtremeBindGate(store.currentMode)
  const resetTimePending = isResetTimePending(store.resetTime)
  const [justVerified, setJustVerified] = useState(false)
  const [justVerified2, setJustVerified2] = useState(false)

  // 非 iOS-Cloud 离开本页（基础/高级绑定仅 iOS）
  useEffect(() => {
    if (isIos) return
    router.replace(getDashboardPathByPlatform(platformType))
  }, [isIos, platformType, deviceSwitchRevision, router])

  // 侧栏选中空包后勿停留在高级验证页（避免验证组件回填 DeviceUser 冲掉选中态）
  useEffect(() => {
    if (!isUnboundPackageSelectionActive()) return

    const orderId = readCachedBindOrderId()
    router.replace(appendSetupQuery('/setup', orderId || undefined))
  }, [deviceSwitchRevision, router])

  if (!isIos || isUnboundPackageSelectionActive()) {
    return <div className='min-h-[calc(var(--vh2)*100-200px)] w-full' aria-hidden />
  }

  return (
    <div className='Bxl:h-[calc(var(--vh2)*100-90px)] Bxls:Headers5:h-[calc(var(--vh2)*100-145px)] Header5:big:h-[calc(var(--vh2)*100-210px)] bigs:h-[calc(var(--vh2)*100-270px)]'>
      <div className='w-full h-full flex justify-center pt-[90px] Mlg:pt-[40px] bg-white rounded-[10px] absolute top-0 left-0 z-[88] overflow-auto'>
        {!resetTimePending && !justVerified && !justVerified2 && (
          <ExtremeVerfiy setJustVerified={setJustVerified} />
        )}
        {!resetTimePending && justVerified && !justVerified2 && (
          <Backup setJustVerified2={setJustVerified2} />
        )}
        {!resetTimePending && justVerified2 && <Congratulations />}
      </div>
    </div>
  )
}

export default IosExtreme
